import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useLogout } from 'js/hooks/auth';
import { useTranslations } from 'js/hooks/i18n';
import { useConfirmationPopup } from 'js/components/common/popups/ConfirmationPopup';

export const useLegacyLogoutHandler = () => {
    const showConfirmationPopup = useConfirmationPopup();
    const translate = useTranslations('playtech.mobile.system.');
    const logout = useLogout();

    useEffect(() => {
        const invokeLogoutConfirmation = () => {
            showConfirmationPopup({
                content: translate('logoutconfirm.title'),
                acceptBtnText: translate('logout.button.title'),
                declineBtnText: translate('cancel.button.title'),
                onAccept: () => logout(),
                isModal: false,
                className: 'logout-confirm-popup'
            });
        };

        dispatcher.listen('auth:action:logout', invokeLogoutConfirmation);

        return () => {
            dispatcher.removeListener('auth:action:logout', invokeLogoutConfirmation);
        };
    }, [translate, logout, showConfirmationPopup]);
};
